import {
  $isAutoLinkNode, $isLinkNode, SerializedLinkNode,
} from '@lexical/link';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $findMatchingParent } from '@lexical/utils';
import React from 'react';
import useFloatingEditorState, { FindNodeFunc } from '../Hooks/useFloatingEditorState';
import FloatingLinkView from './Components/FloatingLinkView';
import StyledPopover from './styles';
import FloatingLinkEdit from './Components/FloatingLinkEdit';

export const findLink: FindNodeFunc<SerializedLinkNode> = (node, selection) => {
  if (!selection) return null;
  const linkParent = $findMatchingParent(node, $isLinkNode);
  const autoLinkParent = $findMatchingParent(node, $isAutoLinkNode);

  if (linkParent != null && autoLinkParent == null) {
    if (selection.anchor.offset === node.getTextContent()?.length || selection.anchor.offset === 0) {
      return null;
    }
    return linkParent.exportJSON() as SerializedLinkNode;
  }
  return null;
};

export default function FloatingLinkEditor() {
  const [editor] = useLexicalComposerContext();
  const [activeEditor, current, close] = useFloatingEditorState(editor, findLink);
  const [isEditing, setIsEditing] = React.useState(false);

  React.useEffect(() => {
    if (!current) setIsEditing(false);
  }, [current]);

  return (
    <StyledPopover
      anchorEl={current?.anchorEl}
      open={!!current}
      keepMounted
      disableAutoFocus
      disableEnforceFocus
      transformOrigin={{ vertical: -4, horizontal: 'left' }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      elevation={8}
    >
      {isEditing
        ? (
          <FloatingLinkEdit
            initUrl={current?.node.url ?? 'https://'}
            stopEditing={() => { setIsEditing(false); }}
            editor={activeEditor}
          />
        )
        : (
          <FloatingLinkView
            startEditing={() => { setIsEditing(true); }}
            url={current?.node.url ?? 'https://'}
            editor={activeEditor}
            close={close}
          />
        )}
    </StyledPopover>
  );
}
